import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A padmount transformer: the green steel box on a concrete pad you see on
// suburban verges, stepping distribution voltage down for the street. Tamper
// covers, cooling louvres, a warning label and a small cable plinth.
const GREEN = "#3a6b4a";
const GREEN_DK = "#2e5a3d";
const PAD = "#9a948a";
const WARN = "#f2c14e";

export const padmountTransformer = defineModel({
  id: "padmount-transformer",
  batchId: "electric",
  name: "Padmount transformer",
  tags: ["prop", "electric", "power", "grid", "distribution", "transformer"],
  summary: "A green padmount transformer on a concrete pad.",
  footprint: 0.35,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(0.62, 0.08, 0.5), color: PAD, position: [0, 0.04, 0] },
      // Main cabinet, slightly tapering lid.
      { geometry: new THREE.BoxGeometry(0.5, 0.44, 0.4), color: GREEN, position: [0, 0.3, 0] },
      { geometry: new THREE.BoxGeometry(0.54, 0.05, 0.44), color: GREEN_DK, position: [0, 0.54, 0] },
      // Front double doors with a centre seam and handles.
      { geometry: new THREE.BoxGeometry(0.46, 0.36, 0.02), color: GREEN_DK, position: [0, 0.3, 0.205] },
      { geometry: new THREE.BoxGeometry(0.012, 0.34, 0.02), color: "#1f3d2a", position: [0, 0.3, 0.216] },
      { geometry: new THREE.BoxGeometry(0.03, 0.06, 0.02), color: "#cfcfcf", position: [-0.06, 0.3, 0.22] },
      { geometry: new THREE.BoxGeometry(0.03, 0.06, 0.02), color: "#cfcfcf", position: [0.06, 0.3, 0.22] },
      // Cooling louvres on the side.
      { geometry: new THREE.BoxGeometry(0.02, 0.04, 0.22), color: GREEN_DK, position: [0.252, 0.36, 0] },
      { geometry: new THREE.BoxGeometry(0.02, 0.04, 0.22), color: GREEN_DK, position: [0.252, 0.28, 0] },
      { geometry: new THREE.BoxGeometry(0.02, 0.04, 0.22), color: GREEN_DK, position: [0.252, 0.2, 0] },
      // Yellow warning label.
      { geometry: new THREE.BoxGeometry(0.1, 0.08, 0.02), color: WARN, position: [0.16, 0.45, 0.21] },
    ];
  },
  animations: [],
});
